import { render, staticRenderFns } from "./OldReferralProgram.vue?vue&type=template&id=3c8644d3&scoped=true&"
import script from "./OldReferralProgram.vue?vue&type=script&lang=js&"
export * from "./OldReferralProgram.vue?vue&type=script&lang=js&"
import style0 from "./OldReferralProgram.vue?vue&type=style&index=0&id=3c8644d3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8644d3",
  null
  
)

export default component.exports